import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59c98c95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-epic-primary-endpoint-frame hd-epic-frame-content" }
const _hoisted_2 = { class: "hd-epic__header" }
const _hoisted_3 = { class: "hd-epic__content-top" }
const _hoisted_4 = { class: "hd-epic__content-copy" }
const _hoisted_5 = { class: "hd-epic__content-top-buttons-group" }
const _hoisted_6 = { class: "hd-epic__content-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_lyra_asset, {
        class: "hd-epic__header-section",
        "asset-key": `epic-header-section-${_ctx.section}`
      }, null, 8, ["asset-key"]),
      _createVNode(_component_lyra_asset, {
        class: "hd-epic__header-title",
        "asset-key": "epic-header-hospitalization-title"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_lyra_asset, {
          class: "hd-epic__content-text",
          "asset-key": "epic-hospitalization-content-top"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeScreen())),
          class: "hd-epic__button hd-epic__button-one"
        }, [
          _createVNode(_component_lyra_asset, { "asset-key": "hd-epic-hospitalization-top-button-one" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_base_image_svg, {
        class: "hd-epic__chart",
        source: require('!html-loader!../../assets/charts/secondary-endpoint-covid-19-related-hospitalization-(mITT1).svg')
      }, null, 8, ["source"])
    ])
  ]))
}